/**
 * USP v1 reader. Calls `__uspapi('getUSPData', 1, cb)` once and parses the
 * 4-char USP string:
 *
 *   Position 1: version ("1")
 *   Position 2: notice given ("Y" / "N" / "-")
 *   Position 3: user opted out ("Y" / "N" / "-")
 *   Position 4: LSPA covered ("Y" / "N" / "-")
 *
 * Opt-out (position 3 = "Y") → 'denied'. Anything else → 'granted'.
 */

import { warn } from '../../util/log';
import { readUspApi } from './cmpApis';

export type UspResult =
  | { kind: 'granted'; uspString: string }
  | { kind: 'denied'; uspString: string }
  | { kind: 'unavailable' };

export function readUsp(): Promise<UspResult> {
  return new Promise<UspResult>((resolve) => {
    const api = readUspApi();
    if (!api) {
      resolve({ kind: 'unavailable' });
      return;
    }
    try {
      api('getUSPData', 1, (data, success) => {
        if (!success || !data || typeof data.uspString !== 'string') {
          resolve({ kind: 'unavailable' });
          return;
        }
        const optedOut = data.uspString.charAt(2) === 'Y';
        resolve({
          kind: optedOut ? 'denied' : 'granted',
          uspString: data.uspString,
        });
      });
    } catch (err) {
      warn('usp getUSPData threw', err);
      resolve({ kind: 'unavailable' });
    }
  });
}
